/**
 * The CLI version is injected at build time via tsup's `define` config.
 * In dev (tsx), CLI_VERSION may be undefined; fall back to a sentinel.
 */
export const CLI_VERSION: string = process.env.CLI_VERSION ?? "0.0.0-dev";
